import { ComponentType } from 'react';
import { FeatureFlag, UserPermission, UserRole } from '@synergy/models';
import { PoolInstance } from '@synergy/config';

import { AccessControl } from './access-control';

export const AccessControlConnect =
    (
        allowedRoles?: UserRole | UserRole[],
        allowedPermissions?: UserPermission | UserPermission[],
        allowedFeature?: FeatureFlag,
        allowedInstance?: PoolInstance,
        redirect = false
    ) =>
    <P extends object>(WrappedComponent: ComponentType<P>) =>
    (props: P) =>
        (
            <AccessControl
                allowedRoles={allowedRoles}
                allowedPermissions={allowedPermissions}
                allowedFeature={allowedFeature}
                allowedInstance={allowedInstance}
                redirect={redirect}
            >
                <WrappedComponent {...props} />
            </AccessControl>
        );
